import axios from 'axios';
import { getApiUrl } from "../../config/api";

// Base URL for the Deals API
const API_URL = getApiUrl('/Deals/');

// Create an Axios instance with default headers
const apiClient = axios.create({
  baseURL: API_URL,
});

// Add an interceptor to include the access token in the headers
apiClient.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem("access_token");
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

/**
 * Fetch all deals.
 */
export const fetchDeals = () => apiClient.get('deals-models-list-create/');

/**
 * Create a new deal.
 * @param {FormData} data - The form data for the new deal.
 */
export const createDeal = (data) => apiClient.post('deals-models-list-create/', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

/**
 * Update an existing deal.
 * @param {number} id - The ID of the deal to update.
 * @param {FormData} data - The updated form data.
 */
export const updateDeal = (id, data) => apiClient.put(`deals-models-detail/${id}/`, data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

/**
 * Delete a deal.
 * @param {number} id - The ID of the deal to delete.
 */
export const deleteDeal = (id) => apiClient.delete(`deals-models-detail/${id}/`);

export default {
    fetchDeals,
    createDeal,
    updateDeal,
    deleteDeal
};
